export const ZIndex = {
  actionSlot: 5,
  card: 9,
  meaple: 10,
  modal: 100,
};
